import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=fdacdde6&"
import script from "./Contacts.vue?vue&type=script&lang=js&"
export * from "./Contacts.vue?vue&type=script&lang=js&"
import style0 from "./Contacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdacdde6')) {
      api.createRecord('fdacdde6', component.options)
    } else {
      api.reload('fdacdde6', component.options)
    }
    module.hot.accept("./Contacts.vue?vue&type=template&id=fdacdde6&", function () {
      api.rerender('fdacdde6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Contacts.vue"
export default component.exports